module.exports = __webpack_public_path__ + "static/media/downArrow.f06acfc6.svg";